// (C) 2021 GoodData Corporation
/**
 * @internal
 */
export var getCssProperty = function (key, value) {
    return value && {
        key: "--gd-" + key,
        value: value,
    };
};
//# sourceMappingURL=cssProperty.js.map